import Box from '@mui/joy/Box';
import IconButton from '@mui/joy/IconButton';
import LogoutRoundedIcon from '@mui/icons-material/LogoutRounded';
import { useTranslation } from 'react-i18next';
import { AccountInfo, useSignOut, Version } from '@consolidocs-ui/components';

/** The foot of the sidebar: the build version, who is signed in, and signing out. */
export default function SidebarFooter() {
  const { t } = useTranslation();
  const { signOut, signingOut } = useSignOut();

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
        gap: 1.5,
        p: 2,
        borderTop: '1px solid',
        borderColor: 'divider',
        flexShrink: 0,
      }}
    >
      <Version variant="inline" placement="above" />

      <Box
        sx={{ display: 'flex', alignItems: 'center', gap: 1, width: '100%' }}
      >
        <Box sx={{ minWidth: 0, flex: 1 }}>
          <AccountInfo />
        </Box>
        <IconButton
          size="sm"
          variant="plain"
          color="neutral"
          aria-label={t('Logout')}
          title={t('Logout')}
          loading={signingOut}
          onClick={signOut}
        >
          <LogoutRoundedIcon />
        </IconButton>
      </Box>
    </Box>
  );
}
